<template>
  <div class="hero is-fullheight" >
    <!-- Hero image -->
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="columns is-vcentered">
          <div class="column is-6 is-offset-3 mb-90">
            <!-- Login form -->
            <div class="animated preFadeInLeft fadeInLeft pb-90" id="printMe">
              <router-link to="/" class="logo">
                <img class src="~/../assets/images/logos/brand-logo.png" alt>
              </router-link>
              <hr>
              <h4 class="title is-4">تم حجز موعد تحقق من بيانات KYC بنجاح</h4>

              <hr>
              <a class="button button-cta primary-btn  is-bold is-large ">
                <b>رقم الحجز {{ customer_id }}</b>
              </a>
              <br>

              <a class="button button-cta primary-btn is-bold is-large mt-20  ">
                <b>يوم {{ customerdate }}</b>
              </a>
              <br>

              <a class="button button-cta primary-btn is-bold is-large mt-20  ">
                <b>بتوقيت {{ customertime }}</b>
              </a>
              <hr>

              <h4 class="title is-4">رجاء الالتزام بالحضور</h4>
              <hr>
            </div>
            <div class="mt-20">


   <a
                  class="button is-info btn-align modal-dismiss is-bold is-medium ml-20"
                  @click="print"
                >
                  <b>طباعة</b>
                </a>

              <router-link to="/">
                <a
                  class="button is-dark btn-align modal-dismiss is-bold is-medium"
                >
                  <b>عودة للرئيسية</b>
                </a>


              </router-link>



            </div>

            <div class="hero-foot has-text-centered mt-20"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import arabic from "vee-validate/dist/locale/ar";
import moment from "moment";

const today = new Date();
const min = new Date();
min.setHours(9);
min.setMinutes(0);
const max = new Date();
max.setHours(18);
max.setMinutes(0);
export default {
  name: "booking",
  props: ["customerdate", "customertime", "customer_id"],

  data() {
    return {
      customerdate: null,
      customertime: null,
      customer_id: null
    };
  },
  created() {
    if (this.customerdate == null || this.customertime == null) {
      this.$router.push("/");
    }
  },
    methods: {
    print() {
      // Pass the element id here
      this.$htmlToPaper('printMe');
    }
  }
};
</script>
